// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FormatsTree.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Format Data Tree component
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import List from 'share/components/controls/Izenda.List';
import Panel from 'share/components/controls/Izenda.Panel';
import OverflowText from 'share/components/controls/Izenda.OverflowText';
import DnDFormatItemConfig from 'modules/ReportDesigner/Formats/Izenda.DnDFormatsConfig';
import ReportBodyConstants from 'logic/data/Izenda.ReportBodyConstants';
import draggable from 'share/components/hoc/Izenda.Draggable';
import { isEmpty } from 'lodash/fp';

@observer
class TopItemHeaderComponent extends Component {
  onChange = (e: any) => {
    this.props.onChange(e.target.checked);
  };
  render() {
    const { name, visible, items } = this.props.topItem;
    return (
      <OverflowText text={name} tooltip={name}>
        <input
          className="pull-left u_marginRightInnerSpace"
          type="checkbox"
          checked={visible}
          onChange={this.onChange}
        />
        <div onClick={this.props.collapseToggle}>
          <span>{name}</span>
          {isEmpty(items) ? null : (
            <a>
              <i className="icon-toggle-triangle" />
            </a>
          )}
        </div>
      </OverflowText>
    );
  }
}

const Item = observer(({ subItem: { label } }) => (
  <OverflowText key={label} text={label} tooltip={label}>
    {label}
  </OverflowText>
));

const DraggableItem = draggable(
  ReportBodyConstants.DRAG_ITEM.REPORT_PART_FIELD_ITEM,
  DnDFormatItemConfig.sourceOptions
)(Item);

@observer
class FormatsTree extends Component {
  render() {
    const { store, store: { reportFormats: { name } } } = this.props;

    const FormatHeaderComponent = () => (
      <OverflowText text={name} tooltip={name} onClick={this.props.collapseToggle}>
        {name}
        <a>
          <i className="icon-toggle-triangle" />
        </a>
      </OverflowText>
    );

    const header = {
      component: FormatHeaderComponent
    };

    return (
      <Panel header={header} collapsible initState className="Izenda-FormatTree_Panel u_fullHeight">
        {this.renderFormats(store)}
      </Panel>
    );
  }

  /**
   * Render list format item in middle panel
   * @param {Object} store
   */
  renderFormats(store: any) {
    const { reportFormats: { headerFooter, titleDescription } } = store;
    const topItems = [headerFooter, titleDescription];

    const renderTopItem = (topItem: any, index: number) => {
      const renderListSubItem = () => {
        if (isEmpty(topItem.items)) {
          return null;
        }
        return <List>{topItem.items.map((subItem, index) => <DraggableItem key={index} subItem={subItem} />)}</List>;
      };

      // set item visible or not
      const handleVisibleChanged = (checked: boolean) => {
        topItem.setVisible(checked);

        !checked && store.reportStore.resetShowingHeaderFooter();
      };

      const header = {
        component: TopItemHeaderComponent,
        onChange: handleVisibleChanged,
        topItem: topItem
      };

      return (
        <Panel key={index} header={header} collapsible initState>
          {renderListSubItem()}
        </Panel>
      );
    };

    return <section>{topItems.map(renderTopItem)}</section>;
  }
}

export default FormatsTree;



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Formats/Izenda.FormatsTree.js